import { useEffect, useState, useCallback } from "react";
import axios from "axios";

import { BACKEND_URL } from '../utils/apiBase';
const API = `${BACKEND_URL}/api`;

/**
 * Polls the dry-run simulation_mode flag for an event.
 * Returns { simulationMode, setSimulationMode, refresh }.
 */
export default function useSimulationMode(eventId, intervalMs = 5000) {
  const [simulationMode, setSimulationModeState] = useState(false);

  const refresh = useCallback(async () => {
    if (!eventId) return;
    try {
      const res = await axios.get(`${API}/dry-run/event/${eventId}/status`);
      setSimulationModeState(!!res.data?.simulation_mode);
    } catch {
      /* ignore */
    }
  }, [eventId]);

  useEffect(() => {
    if (!eventId) return undefined;
    refresh();
    const iv = setInterval(refresh, intervalMs);
    return () => clearInterval(iv);
  }, [eventId, intervalMs, refresh]);

  const setSimulationMode = useCallback(
    async (enabled) => {
      if (!eventId) return;
      const res = await axios.put(
        `${API}/dry-run/event/${eventId}/status`,
        { enabled }
      );
      setSimulationModeState(!!res.data?.simulation_mode);
    },
    [eventId]
  );

  return { simulationMode, setSimulationMode, refresh };
}
